export default "<img class=\"{{ class }}\" [src]=\"secure ? (imageUrl | secureUrl | async) : imageUrl\" alt=\"{{ imageAlt }}\" />"